import React from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';

ChartJS.register(ArcElement, Tooltip, Legend);


function App({data}) {
  return <Doughnut data={data} style={{ marginTop: 10 }} />;
}

export default App;
